import React from "react";
import AddFOBIndicationIcon from "../svg/addFOBIndicationIcon.svg?react";
import IndicationHistoryIcon from "../svg/indicationHitoryIcon.svg?react";
import LocationIcon from "../svg/locationIcon.svg?react";
import TrashCanIcon from "../svg/trashCanIcon.svg?react";
// import ViewGuidanceIcon from "../svg/viewGuidanceIcon.svg?react";

export interface MenuItemConfig {
  id: string;
  label: string;
  icon: React.ReactNode;
  action: any;
  className?: string;
}

export const kochMenuItems: MenuItemConfig[] = [
  {
    id: "overview",
    label: "Location Overview",
    icon: <LocationIcon />,
    action: "overview",
    className: "text-default",
  },
  // {
  //   id: "guidance",
  //   label: "View Guidance",
  //   icon: <ViewGuidanceIcon />,
  //   action: "guidance",
  //   className: "text-blue",
  // },
  {
    id: "remove",
    label: "Remove Location",
    icon: <TrashCanIcon />,
    action: "remove",
    className: "text-red",
  },
];

export const competitorMenuItems: MenuItemConfig[] = [
  {
    id: "overview",
    label: "Location Overview",
    icon: <LocationIcon />,
    action: "overview",
    className: "text-default",
  },
  {
    id: "add-fob",
    label: "Add FOB Indication",
    icon: <AddFOBIndicationIcon />,
    action: "add-fob",
    className: "text-green",
  },
  {
    id: "history",
    label: "Indication History",
    icon: <IndicationHistoryIcon />,
    action: "history",
    className: "text-blue",
  },
  {
    id: "remove",
    label: "Remove Location",
    icon: <TrashCanIcon />,
    action: "remove",
    className: "text-red",
  },
];
